<section id="history" class="page-banner parallax-section">
    <div class="container-fluid text-center">
        <div class="row">
            <!-- <div class=" wow fadeInLeft col-md-1">
                <div class="d-flex" style="height: 100px;">
                    <div class="vr"></div>
                  </div>
            </div> -->
            <div class="wow fadeInUp offset-md-3 col-md-6 col-sm-7 " data-wow-delay="0.6s">
                <h1>History</h1>
                <ul>
                  <li>
                    <a routerlink="/" href="/">Home</a>
                  </li>
                  <li>History</li>
                </ul>
            </div>
        </div> 
    </div>
</section>

<div class="history">
    <div class="container">
        <div class="row">
            
            <div class="wow fadeInLeft col-md-8 col-sm-12 d-flex align-items-center flex-column justify-content-center text-justify" data-wow-delay="0.6s">
                <div class="container text-center mb-5">
                    <!-- <h1>Trusted by thousands</h1> -->
                </div>
                <p>7107 Islands Placement and Promotions, Inc. is a Philippine Overseas Employment Agency (POEA) registered 
                  overseas manpower placement agency with over 20 years-experience in the deployment of qualified 
                  semi-skilled and skilled workers, engineers, medical professionals, and overseas Filipino workers (OFWs) with 
                  specialized skills trainings to Asian, Western, European, and Middle East countries</p>
                <p>Acquired by its Chairman Joel P. Longares in 2003, 7107 Islands has since then shifted its deployment thrust of 
                  overseas Filipino workers (OFWs) to professionals, skilled and semi-skilled and those with specialized trainings 
                  to big names in global business like Samsung, Hyundai and Hiap Seng companies among others,</p>
            </div>
<!-- 
            <div class=" col-md-6 col-sm-12" data-wow-delay="0.6s">
                <img src="/assets/images/details-img.jpg" class="img-fluid" alt="">
            </div> -->
            <div class="col-md-4 wow fadeInRight" data-wow-delay="0.6s">
              <div class="mt-5 mb-5 d-flex align-items-center justify-content-center flex-column text-center">
                <a href="https://dmw.gov.ph/onlineservices" target="_blank" title="DEPARTMENT OF MIGRANT WORKERS">
                  <img src="/assets/images/dmw-logo.png" alt="" style="width: 75%;">
                </a>
                <h4>DMW-License No.:</h4>
                <p>DMW-024-LB-03072023-R</p>
              </div>
          </div>

            <!-- <div class="wow fadeInUp col-md-12 col-sm-12 pt-5" data-wow-delay="0.3s">
                <img src="/assets/images/7107/image (4).jpg" class="img-fluid" alt="">
            </div> -->

        </div>
    </div>
  </div>

<section id="vision" class="parallax-section">
	<div class="container">
		<div class="row">

			<div class="wow fadeInLeft col-md-offset-1 col-md-5 col-sm-8" data-wow-delay="0.6s">
				<h2>Our Vision</h2>
				<p>To be an industry leader in providing professional and highly competent 
          Filipino human resources for the global market.</p>
			</div>
		</div>
	</div>
</section>

<section id="mission" class="parallax-section">
  <div class="container">
    <div class="row">
      <div class="wow fadeInUp col-md-6 offset-md-3 text-center">
        <h2 class="">OUR MISSION</h2 >
      </div>
      <div class="wow fadeInUp d-flex col-md-4 offset-md-1 pt-5 pb-5" data-wow-delay="0.4s">
        <i class="fa fa-check-square-o"></i>
        <p>To provide qualified, trained and experienced Filipino skilled workers
          and professionals to 7107 Islands local and foreign clients.</p>
      </div>
      <div class="wow fadeInUp d-flex col-md-4 offset-md-1 pt-5 pb-5" data-wow-delay="0.4s">
        <i class="fa fa-check-square-o"></i>
        <p>To provide better service through quality selection and pooling of
          manpower resources</p>
      </div>
      <div class="wow fadeInUp d-flex col-md-4 offset-md-1 pt-5 pb-5" data-wow-delay="0.6s">
        <i class="fa fa-check-square-o"></i>
        <p>To provide overseas employment opportunities for Filipinos.</p>
      </div>
      <div class="wow fadeInUp d-flex col-md-4 offset-md-1 pt-5 pb-5" data-wow-delay="0.6s">
        <i class="fa fa-check-square-o"></i>
        <p>To help the Philippine economy with 7107 Islands deployed workers’
          foreign currency remittances.</p>
      </div>
      <div class="wow fadeInUp d-flex col-md-6 offset-md-3 pt-5 pb-5" data-wow-delay="0.8s">
        <i class="fa fa-check-square-o"></i>
        <p>To deliver utmost and sincere service to our Filipino clients and
          business partners from other parts of the world.</p>
      </div>
    </div>
  </div>
</section>

<!-- JPL GROUP OF COMPANIES -->
<section id="jpl-companies" class="our-process p-0 m-0 bg-silver">
  <div class="container work-process  pb-5 pt-5">
    <div class="title text-center">
      <h2 class="content-title">JPL GROUP OF COMPANIES</h2>
    </div>
  </div>
  <div class="container pb-3">
    <div class="row text-center ">
      <div class="company-logo col-md-8 offset-md-2">
        <img class="img-fluid" src="/assets/images/logo/axpn.png" alt="">
      </div>
      <div class="company-logo col-md-6 offset-md-3">
        <img class="img-fluid" src="/assets/images/logo/abxp.png" alt="">
      </div>
      <div class="company-logo col-md-6">
        <img class=" img-fluid" src="/assets/images/logo/LogoInc.png" alt="">
      </div>
      <div class="company-logo col-md-6">
        <img class=" img-fluid" src="/assets/images/logo/logo-e-market.png" alt="">
      </div>
      <div class="company-logo col-md-6">
        <img class=" img-fluid" src="/assets/images/logo/uniteller.png" alt="">
      </div>
      <div class="company-logo col-md-6">
        <img class=" img-fluid" src="/assets/images/logo/rem.png" alt="">
      </div>
      <div class="company-logo col-md-8 offset-md-2">
        <img class=" img-fluid" src="/assets/images/logo/partner-jolong.png" alt="">
      </div>
    </div>
  </div>
</section>